import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.localCompliance,"item-text":"name","item-value":"value","hide-no-data":"","label":_vm.$t('labels.type'),"required":"","error-messages":_vm.errors,"menu-props":{ maxWidth: '316px', closeOnContentClick: true }},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }